import Vue from 'vue'
import { geeInit } from '@/views/user/account/information/service/service'

Vue.prototype.$geetest = async ({ el, product = 'bind', onSuccess }) => {
  require('@/plugins/gt')
  const { success, message, data } = await geeInit()

  if (success) {
    const { gt, challenge, new_captcha, success: offline } = data
    window.initGeetest({ gt, challenge, offline: !offline, new_captcha, width: '100%', product }, captchaObj => {
      // 监听验证加载完成
      captchaObj.onReady(() => {
        captchaObj.verify()
      })
      // 监听验证成功
      captchaObj.onSuccess(async () => {
        if (typeof onSuccess === 'function') {
          onSuccess(captchaObj.getValidate())
        }
      })
    })
  } else {
    Vue.prototype.$error(message)
  }
}
